module.exports = __webpack_public_path__ + "img/icon-linkedin.bb3d7f13.svg";